import EF from 'ef/ef';
import CourseSettingsService from 'services/course-handler-services/course-settings-service';
import utils from 'lib/utils';
import Chaplin from 'chaplin';
import Location from 'ef/models/location';

const LocationsCollection = Chaplin.Collection.extend({
  model: Location,
  comparator: 'id',

  initialize(options) {
    if (options && options.localData) {
      this.data = options.localData;
    }
    Chaplin.Collection.prototype.initialize.apply(this, arguments);
  },

  fetch() {
    if (CourseSettingsService.get('local')) {
      return new Promise(resolve => {
        const localData = this.data || utils.tryRequire('local-data/locations.json');
        this.set(utils.sanifyJsonApiObject(localData.data, localData.included).map(l => new Location(l)));
        return resolve(this);
      });
    } else {
      return fetch(`${CourseSettingsService.get('portalBasePath')}/locations.json`, {
        headers: {
          Authorization: `Bearer ${EF.config.get('jwt')}`,
          Accept: 'application/json',
        },
        credentials: 'include',
      })
        .then(response => response.json())
        .then(response => {
          this.set(utils.sanifyJsonApiObject(response.data, response.included).map(l => new Location(l)));
          return Promise.resolve(this);
        });
    }
  },
});

export default LocationsCollection;
